import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import FormErrorLabel from "../../FormErrorLabel/FormErrorLabel";

export const CustomeTimePicker = (props) => {
  const { errorMsg } = props;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["TimePicker"]}>
        <DesktopTimePicker {...props} />
      </DemoContainer>
      {errorMsg && <FormErrorLabel errorMsg={errorMsg} />}
    </LocalizationProvider>
  );
};

export default CustomeTimePicker;
